module.exports = __webpack_public_path__ + "static/img/partner-hxcx.f43758b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-hxcx.png
// module id = 5aX3
// module chunks = 34